import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { WebcamModule } from 'ngx-webcam';
import { PopoverModule } from '@easiangular/ngx-smart-popover';
import { IonicModule } from '@ionic/angular';
import { FilterActivities } from '../pipes/filter-activities';
import { FilterTasksPipe } from '../pipes/filter-tasks.pipe';
import { FilterWorkoutsPipe } from '../pipes/filter-workouts.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { MemberCardComponent } from './components/member-card/member-card.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { WebcamComponent } from './components/webcam/webcam.component';
import { MemberFeeCardComponent } from './components/member-fee-card/member-fee-card.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        AngularEditorModule,
        WebcamModule,
        PopoverModule,
        IonicModule
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NoDataComponent,
        FilterActivities,
        LoadingComponent,
        AngularEditorModule,
        SuccessModalComponent,
        WarningModalComponent,
        ErrorModalComponent,
        FilterTasksPipe,
        FilterWorkoutsPipe,
        FilterPipeModule,
        ZXingScannerModule,
        WebcamComponent,
        MemberCardComponent,
        MemberFeeCardComponent,
        PopoverModule
    ],
    declarations: [
        NoDataComponent,
        FilterActivities,
        LoadingComponent,
        SuccessModalComponent,
        WarningModalComponent,
        MemberCardComponent,
        FilterTasksPipe,
        FilterWorkoutsPipe,
        ErrorModalComponent,
        WebcamComponent,
        MemberFeeCardComponent
    ],
    providers: [
    ]
})
export class SharedModule { }
